;(function () {
  const initBulkGallery = () => {
    document.querySelectorAll('.gallery-bulk').forEach(section => {
      if (section.classList.contains('gallery-bulk_started')) return
      section.classList.add('gallery-bulk_started')

      const id = section.getAttribute('id')
      const swiperSelector = `#${id} .gallery-bulk__swiper`
      const speed = (section.dataset.speed || section.getAttribute('data-speed') || 6) * 1000

    const swiper = new Swiper(`#${id} .gallery-bulk__swiper`, {
    loop: true,
    speed: speed,
    centeredSlides: true,
    allowTouchMove: true,
    autoplay: {
        delay: 0,
        disableOnInteraction: false,
    },
    spaceBetween: 12,
    breakpoints: {
        0: {
        slidesPerView: 1.25,
        },
        360: {
        slidesPerView: 1.7,
        },
        480: {
        slidesPerView: 2.2,
        },
        640: {
        slidesPerView: 2.5,
        },
        850: {
        slidesPerView: 3,
        },
        1200: {
        slidesPerView: 3.5,
        },
        1600: {
        slidesPerView: 4.5,
        },
    },
    });
    
      /* ---- STOP / PLAY BUTTON ---- */
      const stopBtn = section.querySelector('.gallery-bulk_stop')

      if (stopBtn) {
        stopBtn.addEventListener('click', () => {
          const isActive = stopBtn.classList.contains('gallery-bulk_stop_active')

          if (isActive) {
            stopBtn.classList.remove('gallery-bulk_stop_active')
            swiper.autoplay.start()
          } else {
            stopBtn.classList.add('gallery-bulk_stop_active')
            swiper.autoplay.stop()
          }
        })
      }
    })
  }

  document.addEventListener('DOMContentLoaded', initBulkGallery)
  document.addEventListener('shopify:section:load', initBulkGallery)

  document.addEventListener("click", function(e) {
  const btn = e.target.closest(".js-open-media");
  if (!btn) return;

  const mediaId = btn.getAttribute("data-media-id");
  const modal = document.querySelector("product-modal");
  if (!modal) return;

  modal.openedBy = btn; // مهم جداً
  btn.setAttribute("data-media-id", mediaId);

  modal.show(btn);

  // نقل السلايد
  const activeSlider = modal.querySelector(".js-popup-slider")?.swiper;
  if (activeSlider) {
    const index = [...modal.querySelectorAll("[data-media-modal-id]")]
      .findIndex(item => item.getAttribute("data-media-modal-id") === mediaId);

    if (index >= 0) activeSlider.slideTo(index, 0);
  }
});

})()
